import React from 'react';

import classes from './GradingGuideInput.module.css';
import CloseIcon from '../../../assets/icons/icon-close-black.svg';

const GradingGuideInput = (props) => {
    return (
        <>
            <div className={classes.GradingGuideInputContainer}>

                <div className={classes.OptionContainer}>
                    <div className={[classes.TextInputContainer, classes.Objective].join(' ')}>
                        <input
                            type="text"
                            placeholder={"Objective #" + (props.pos + 1)}
                            value={props.value}
                            className={classes.TextInput}
                            onChange={(event) => props.onInputChanged(event, props.pos, 'objective')} />
                        <p className={classes.ErrorMessage}>{props.errorMessage}</p>
                    </div>
                    <div className={[classes.TextInputContainer, classes.Score].join(' ')}>
                        <input
                            type="text"
                            placeholder={"MaxScore #" + (props.pos + 1)}
                            value={props.maxScore}
                            className={classes.TextInput}
                            onChange={(event) => props.onInputChanged(event, props.pos, 'score')} />
                        <p className={classes.ErrorMessage}>{props.scoreErrorMessage}</p>
                    </div>
                    {props.pos === 0 ? null
                        : <img
                            className={[classes.InputIcon, props.pos === 0 ? classes.Hide : ''].join(' ')}
                            src={CloseIcon} alt="Remove Option"
                            title="Delete Grading Criteria"
                            onClick={() => props.removeOptionClick(props.pos)}
                        />
                    }
                </div>


            </div>
        </>
    );
}

export default GradingGuideInput;